import { render, staticRenderFns } from "./ExternalSigner.vue?vue&type=template&id=71041319&"
import script from "./ExternalSigner.vue?vue&type=script&lang=js&"
export * from "./ExternalSigner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports